var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5C3.5 6.1 3.5 5.4 3.772 4.865C4.01173 4.39435 4.39435 4.01173 4.865 3.772C5.4 3.5 6.1 3.5 7.5 3.5H16.5C17.9 3.5 18.6 3.5 19.135 3.772C19.6053 4.0119 19.9875 4.39451 20.227 4.865C20.5 5.4 20.5 6.1 20.5 7.5V16.5C20.5 17.9 20.5 18.6 20.227 19.135C19.9874 19.6051 19.6051 19.9874 19.135 20.227C18.6 20.5 17.9 20.5 16.5 20.5H7.5C6.1 20.5 5.4 20.5 4.865 20.227C4.39451 19.9875 4.0119 19.6053 3.772 19.135C3.5 18.6 3.5 17.9 3.5 16.5V7.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5C9.60457 13.5 10.5 12.6046 10.5 11.5C10.5 10.3954 9.60457 9.5 8.5 9.5C7.39543 9.5 6.5 10.3954 6.5 11.5C6.5 12.6046 7.39543 13.5 8.5 13.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5H15.5M15.5 11.5H17.35C17.3898 11.5 17.4279 11.5158 17.4561 11.5439C17.4842 11.5721 17.5 11.6102 17.5 11.65V13.5M15.5 11.5V13.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.039e1549f05695883fa388378bc5b6bc.svg";
export { ForwardRef as ReactComponent };